import { Column, Editing, Lookup } from 'devextreme-react/data-grid';
import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../components/common/breadcrumb';
import DatagridCustom from '../../components/common/datagrid/custom-datagrid';
import api from '../../services/api-configuration';
import { getAllWarehouses } from '../../services/apis';

const AdreslemeConfig = () => {
    const [dataSources, setDataSources] = useState([]);
    const [warehouses, setWarehouses] = useState([]);

    const DIRECTION = [
        { direction: 'START', name: 'BAŞTAN' },
        { direction: 'END', name: 'SONDAN' }
    ];

    const ilerleme_yonu = [
        { scan_type: 'VERTICAL', name: 'DİKEY' },
        { scan_type: 'HORIZONTAL', name: 'YATAY' }
    ];

    const TYPE = [
        { algorithm_type: 'FILL_ALL', name: 'TAMAMINI DOLDUR' },
        { algorithm_type: 'X_COUNT', name: 'ADET GİR' }
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const warehousesRes = await getAllWarehouses();
                setWarehouses(warehousesRes);

                const response = await api.post("/autoAddressing/getAll");
                // Filter out records where warehouse doesn't exist in warehouses list
                const filteredData = (response.data || []).filter(item =>
                    warehousesRes.some(warehouse => warehouse.warehouse_code === item.warehouse_code)
                );
                setDataSources(filteredData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <Breadcrumb current="Adresleme Konfigürasyonu" />

            <div className="container-fluid card p-4 m-2">
                <DatagridCustom
                    dataSource={dataSources}
                >
                    <Editing
                        allowUpdating
                        useIcons
                    />
                    <Column
                        caption='Depo Kodu'
                        dataField='warehouse_code'
                        allowEditing={false}
                        alignment='center'
                    >
                        <Lookup
                            dataSource={warehouses}
                            valueExpr="warehouse_code"
                            displayExpr="warehouse_name"
                        />
                    </Column>
                    <Column
                        caption='Algoritma Türü'
                        dataField='algorithm_type'
                        alignment='center'
                        setCellValue={(rowData, value) => {
                            rowData.algorithm_type = value;
                            if (value === 'FILL_ALL') {
                                rowData.x_count = null;
                            }
                            return rowData;
                        }}
                    >
                        <Lookup
                            dataSource={TYPE}
                            valueExpr="algorithm_type"
                            displayExpr="name"
                        />
                    </Column>
                    <Column
                        caption='Adet'
                        dataField='x_count'
                        alignment='center'
                        allowEditing={(rowData) => rowData.algorithm_type === 'X_COUNT'}
                    />
                    <Column
                        caption='Yön'
                        dataField='direction'
                        alignment='center'
                    >
                        <Lookup
                            dataSource={DIRECTION}
                            valueExpr="direction"
                            displayExpr="name"
                        />
                    </Column>
                    <Column
                        caption='İlerleme Yönü'
                        dataField='scan_type'
                        alignment='center'
                    >
                        <Lookup
                            dataSource={ilerleme_yonu}
                            valueExpr="scan_type"
                            displayExpr="name"
                        />
                    </Column>
                </DatagridCustom>
            </div>
            <hr />
        </>
    );
};

export default AdreslemeConfig;